import { Platform } from '../types';

export const isSsrEnabledInPlatform = (platform: Platform) =>
  platform === Platform.Viewer;
